import { render, staticRenderFns } from "./BuyMobile.vue?vue&type=template&id=7166d385&"
import script from "./BuyMobile.vue?vue&type=script&lang=js&"
export * from "./BuyMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports